import { ProjectLocationEditor } from "@components/project-location-editor/project-location-editor";
import { BaseProjectProps } from "@custom-types/project-types";
import { MapLargeIcon, MenuItem } from "@flat-ui";
import { trackOpenProjectLocationEditor } from "@utils/project-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";

interface Props extends BaseProjectProps {
  /** Callback function to close the the parent menu component */
  closeMenu(): void;
}

/**
 * Menu item component that opens the ProjectLocationEditor dialog when clicked.
 */
export function ProjectLocationEditorMenuItem({
  project,
  closeMenu,
}: Props): JSX.Element {
  const { trackEvent } = useTrackEvent();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  /** Sets dialog to open and tracks the event */
  function openDialog(): void {
    trackOpenProjectLocationEditor({
      trackEvent,
      source: "projects map view",
    });
    setIsDialogOpen(true);
  }

  /** Closes the dialog and the parent menu */
  function closeDialog(): void {
    closeMenu();
    setIsDialogOpen(false);
  }

  return (
    <>
      <MenuItem
        label="Edit location"
        Icon={MapLargeIcon}
        onClick={openDialog}
      />
      {isDialogOpen && (
        // MUI Menu component has a "typeahead" feature to focus and a menu item by typing.
        // This causes and issue where the ProjectLocationEditor dialog input fields might
        // lose focus when the user types because the focus is moved to the menu item.
        // To prevent this, we stop the propagation of the keydown event so that it doesn't
        // reach the project menu.
        <div onKeyDown={(e) => e.stopPropagation()}>
          <ProjectLocationEditor project={project} onClose={closeDialog} />
        </div>
      )}
    </>
  );
}
